goog.provide("shadow.js.shim.module$dayjs$locale$ca");
goog.provide("module$shadow_js_shim_module$dayjs$locale$ca");
shadow.js.shim.module$dayjs$locale$ca = shadow.js.nativeProvides["dayjs/locale/ca"] = require("dayjs/locale/ca");
module$shadow_js_shim_module$dayjs$locale$ca.default = shadow.js.shim.module$dayjs$locale$ca;
